// export const api_url = 'https://test-accessalliance.rionetworkonline.ca/accessalliance/'
export const api_url = 'https://www.rionetworkonline.ca/accessalliance/'